import { defineStore } from "pinia";
import { ref } from "vue";
import { DateFormats, TimeZones } from "@/constants";
import type { valueOf } from "@/types";
import { StorageHelper } from "@/utils/StorageHelper";
import { StorageName } from "@/utils/StorageHelper/constants";
import { initializeTimeZone } from "@/dayjs";


export const useDateFormatStore = defineStore("dateFormatStore", () => {
    const globalDateFormat = ref<string>(DateFormats.EuropeanDate);
    const globalDateTimeFormat = ref<string>(DateFormats.EuropeanDateTime);
    const globalTimeZone = ref<valueOf<TimeZones>>(TimeZones.EuropeBerlin);

    const { write, read } = new StorageHelper(StorageName.AppTimeZone);

    const changeTimeZone = (timeZone: valueOf<TimeZones>) => {
        globalTimeZone.value = timeZone;

        write(timeZone);

        initializeTimeZone();
    };

    const initialize = async () => {
        const storedTimeZone = read<string>();

        if (!storedTimeZone) return;

        globalTimeZone.value = storedTimeZone;

        return Promise.resolve();
    };

    return { globalDateFormat, globalDateTimeFormat, globalTimeZone, changeTimeZone, initialize };
});
